import { useEffect } from "react";

/**
 * Listens for handheld barcode scanners in keyboard (HID) mode, app-wide:
 * mount once in the app shell. Recognised bursts are normalized and handed
 * to the screen's `useScan` handler; focus never moves and keys typed into
 * a text field stay there (see keyboardWedge.ts). The listener and the
 * barcode rules load just after the shell, so the first paint does not wait
 * for them.
 */
export function useHardwareScanner(enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    let off: (() => void) | null = null,
      cancelled = false;
    import("./install")
      .then((m) => {
        if (!cancelled) off = m.installHardwareScanner();
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
      off?.();
    };
  }, [enabled]);
}
